import React, { useEffect, useState } from 'react';
import { BellRing, ChevronDown, ChevronUp } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { alertasCuidadoAPI } from '../services/api';
import { useAuth } from '../context/AuthContext';
import { MotivosAlerta, SINAIS } from '../pages/radar/AbaAlertas';

/**
 * Aviso do Radar na ficha: a pessoa tem um Alerta de Cuidado em aberto (gasto
 * acelerou, investigação ou alto custo começou). Só aparece para quem tem o
 * Radar liberado; sem alerta aberto, não ocupa espaço.
 */
export default function AlertaCuidadoFicha({ cpf }) {
  const { podeModulo } = useAuth();
  const navigate = useNavigate();
  const [alerta, setAlerta] = useState(null);
  const [aberto, setAberto] = useState(false);
  const pode = podeModulo('radar_carteira');

  useEffect(() => {
    if (!cpf || !pode) { setAlerta(null); return; }
    let vivo = true;
    alertasCuidadoAPI.porCpf(cpf)
      .then((r) => { if (vivo) setAlerta(r.data?.alerta || null); })
      .catch(() => { if (vivo) setAlerta(null); });
    return () => { vivo = false; };
  }, [cpf, pode]);

  if (!alerta) return null;
  const alta = alerta.prioridade === 'Alta';
  const cor = alta ? '#c0392b' : '#e67e22';
  return (
    <div style={{ border: `1px solid ${cor}`, borderLeft: `4px solid ${cor}`, background: alta ? '#fdf2f1' : '#fff8f0', borderRadius: 10, padding: '10px 14px', marginBottom: 16 }}>
      <div onClick={() => setAberto((v) => !v)} style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer' }}>
        <BellRing size={16} color={cor} />
        <strong style={{ fontSize: '0.84rem', color: cor }}>Alerta de cuidado · prioridade {alerta.prioridade}</strong>
        <span style={{ fontSize: '0.76rem', color: '#555', flex: 1 }}>
          {alerta.sinais.map((s) => SINAIS[s]?.rot).filter(Boolean).join(' · ')}
          {alerta.estado === 'acompanhando' ? ' · em acompanhamento' : ''}
        </span>
        {aberto ? <ChevronUp size={16} color="#90a4ae" /> : <ChevronDown size={16} color="#90a4ae" />}
      </div>
      {aberto && (
        <div style={{ marginTop: 10 }}>
          <MotivosAlerta a={alerta} compacto />
          <button onClick={() => navigate('/radar-carteira?aba=alertas')} style={{ marginTop: 10, fontSize: '0.74rem', fontWeight: 600, padding: '5px 12px', borderRadius: 8, cursor: 'pointer', border: `1px solid ${cor}`, background: '#fff', color: cor }}>
            Ver no Radar e registrar acompanhamento
          </button>
        </div>
      )}
    </div>
  );
}
